<template>
	<li class="">
		<a class="uk-accordion-title" href="#">Обратная связь от {{ formatDate(item.date) }}</a>
		<div class="uk-accordion-content">
			<div class="reports__wrap">
        <div v-if="item.format === 'text' || item.format === 'meeting' || item.format === 'missed'">
					<div class="reports__text" v-html="item.desc" v-if="!edit"></div>
					<div v-else>
						<ckeditor v-model="item.desc" :config="editorConfig" type="inline"></ckeditor>
						<button type="button" class="header-menu__btn" @click="updateReport">
              <i class="far fa-save"></i>
              Сохранить изменения
            </button>            
					</div>
				</div>
				<div v-if="item.format === 'audio'" class="reports__audio">
					<audio :src="'storage/app/media' + item.file_name" controls></audio>
				</div>
				<div class="reports__edit" v-if="!edit">
					<span v-if="item.format == 'text'" uk-icon="pencil" @click="editItem" uk-tooltip="Редактировать"></span>
					<span uk-icon="close" @click="onDeleteItem" uk-tooltip="Удалить"></span>
				</div>
			</div>
		</div>
	</li>
</template>

<script>
  import moment from "moment";
  import CKEditor from 'ckeditor4-vue';
  import swal from "sweetalert";

  export default {
    name: "os-item",
    data() {
      return {
        editorConfig: {},
        desc: '',
        date: '',
	      edit: false
      }
    },
    components: {
      ckeditor: CKEditor.component
    },
    props: {
      item: ''
    },
    inject: ['http'],
    methods: {
      editItem() {
	      this.edit = true;
      },
	    updateReport(){
        let data = {
          'id': this.item.id, 'desc': this.item.desc
        }
        this.http.post('onUpdateOs', data).then(() => {
          swal('Обратная связь отредактирована', "", "success");
        });
	    },
      onDeleteItem() {
        swal({
          title: 'Внимание!',
          text: "Действительно желаете удалить обратную связь?",
          icon: "warning",
          buttons: ['Отмена', 'Да'],
          dangerMode: true,
        })
        .then((choise) => {
          if (choise) {
            this.deleteItem();
          } else {
            console.log('cancel');
          }
        });
      },
      deleteItem() {
        let data = {
          'id': this.item.id
        }
        this.http.post('onDeleteOs', data).then((res) => {
          swal('Обратная связь удалена', "", "success");
          let id = this.item.id;
          let items = this.$parent.reports;
          let index = _.findIndex(items, function(o) { return o.id === id; });
          items.splice(index, 1);
        });
      },
      formatDate(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD MMMM YYYY');
      },
    }
  }
</script>

<style lang="scss" scoped>
audio {
  width: 240px;
}
</style>